import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import LoadingApp from '../../../../components/LoadingApp';
import { DadosContaBeneficiario, LstDadosContasCadastradas } from '../../../../interfaces/entities/Reembolso/DadosContaBeneficiario';
import { SecondStepProps } from '../../../../interfaces/props/Financeiro/Reembolso/SecondStepProps';
import { excluirContaReembolso, getDadosContaBeneficiarioProdutoExecutivo, gravaDadosContaReembolso } from '../../../../services/Financeiro/ReembolsoService';
import AccountModal from './AccountModal';
import AccountsTable from './AccountsTable';
import { defaultDadosContaBeneficiario } from './defaultStates';
import './styles.css';
import { sxButton, sxOutlinedButton, sxOutlinedButtonAccessibility } from './sxProps';
import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import { getBenef } from "../../../../Store/storages/BeneficiarioStorage";
import DefaultButton from "../../../../components/Accessibility/DefaultButton";

function StepDadosParaCreditoEmConta(props: SecondStepProps) {
  const [showLoading, setShowLoading] = useState<boolean>(false);
  const [account, setAccount] = useState<LstDadosContasCadastradas | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  const accessibility = useAccessibility();

  const handleNewAccount = async (newAccount: LstDadosContasCadastradas) => {
    setShowLoading(true);
    if (props.idPessoaDependente !== '') {
      const response = await gravaDadosContaReembolso(newAccount, props.idUsrContr, props.idPessoaDependente);

      if (response?.status === 200) {
        const newDadosContaBeneficiario = props.dadosContaBeneficiario;
        newDadosContaBeneficiario.lstDadosContasCadastradas = [...props.dadosContaBeneficiario['lstDadosContasCadastradas'], newAccount];
        props.handleDadosContaBeneficiario();
      } else {
        console.error(response);
      }
    }
    setShowLoading(false);
    setOpen(false);
  }

  const handleEditedAccount = async (editedAccount: LstDadosContasCadastradas, index: number) => {
    setShowLoading(true);
    if (props.idPessoaDependente !== '') {
      const response = await gravaDadosContaReembolso(editedAccount, getBenef()?.idUsrContr.toString() || '', props.idPessoaDependente);
      if (response?.status === 200) {
        let newAccounts = props.dadosContaBeneficiario;
        newAccounts['lstDadosContasCadastradas'][index] = editedAccount;
        props.handleDadosContaBeneficiario();
      } else {
        console.error(response);
      }
    }
    setShowLoading(false);
  }

  const handleDelete = async (index: number) => {
    setShowLoading(true)
    const result = await excluirContaReembolso(props.dadosContaBeneficiario.lstDadosContasCadastradas[index]);
    if (result !== null) {
      const newDadosContaBeneficiario = props.dadosContaBeneficiario;
      newDadosContaBeneficiario.lstDadosContasCadastradas.splice(index, 1);
      props.handleDadosContaBeneficiario();
    }
    setShowLoading(false);
  }

  const handleSecondStep = () => {
    if (account !== null) {
      props.handleSecondStep(account);
    }
  }

  const handleClose = () => {
    setOpen(false);
  }

  const handleOpenModal = () => {
    // setAccount(defaultAccount);
    setOpen(true)
  }

  const handleAccount = (acc: LstDadosContasCadastradas) => {
    setAccount(acc);
  }


  const goBack = () => {
    props.handleBackSecondStep();
  }

  const getAccountIndex = (): string => {
    let index = '';
    if (props.dadosContasCadastradas?.idCadContaReembolso && props.userRequestedToEditInfos) {
      index = props.dadosContaBeneficiario.lstDadosContasCadastradas.findIndex(account =>
        account.idCadContaReembolso === props.dadosContasCadastradas?.idCadContaReembolso
      ).toString();
    }
    return index;
  }

  return (
    <div className="refund-request-second-step-content">
      <LoadingApp showLoading={showLoading} />
      <h2 className="second-step-title" style={accessibility.textStyleAccessibility}>Conta para crédito</h2>
      <div className="second-step-table">
        {props.dadosContaBeneficiario.lstDadosContasCadastradas.length === 0 &&
          <span className="third-step-file">
            Não existe conta cadastrada.
          </span>
        }
        {props.dadosContaBeneficiario.lstDadosContasCadastradas.length > 0 &&
          <AccountsTable dadosContaBeneficiario={props.dadosContaBeneficiario} handleEditedAccount={handleEditedAccount}
            handleDelete={handleDelete} handleAccount={handleAccount} selectedAccountIndex={getAccountIndex()} beneficiary={props.idPessoaDependente}
          />
        }
      </div>
      <div className="second-step-buttons">
        <div className="second-step-button">
          <DefaultButton
            variant="outlined"
            sx={accessibility.contrastMode ? sxOutlinedButtonAccessibility : sxOutlinedButton}
            onClick={handleOpenModal}
            fullWidth>
              <Typography style={{color: '#00995D'}}>
                CADASTRAR NOVA CONTA
              </Typography>
          </DefaultButton>
        </div>
        <div className="second-step-button">
          <Button
            variant="contained"
            sx={sxButton}
            onClick={handleSecondStep}
            disabled={account === null}
            style={accessibility.buttonStyleAccessibility}
            fullWidth>
            <span style={accessibility.buttonTextStyleAccessibility}>
              Continuar
            </span>
          </Button>
        </div>
        <button className="back-button" style={accessibility.textStyleAccessibility} onClick={goBack}>
          <FontAwesomeIcon style={accessibility.textStyleAccessibility} icon={faChevronLeft} />&nbsp;&nbsp;<u>Voltar</u>
        </button>
      </div>
      <AccountModal
        open={open}
        account={null}
        handleClose={handleClose}
        handleConfirm={handleNewAccount}
        dadosContaBeneficiario={props.dadosContaBeneficiario}
        index={-1} />
    </div>
  )
}

export default StepDadosParaCreditoEmConta;